import React from 'react';

import './index.scss'

type MobileProps = {}

const Mobile = ({}: MobileProps): JSX.Element => {
  return (
    <div className="mobile-view-container">
      <div className="header">calvinlee.dev</div>
      <div className="body intro-copy">
        The full experience is designed for a wider view, where the terminal-style landing page has more room to breathe.
      </div>
      <div className="body intro-copy">
        From mobile, you can still jump into a couple of live projects
      </div>
      <div className="projects">
        <div className="projects-list">
          <div className="project-card">
            <div className="project-title">Handball</div>
            <div className="project-copy">
              NYC handball rankings, tournaments, and bracket views in one place.
            </div>
            <a className="project-link" href="/#/handball">Open Handball</a>
          </div>
          <div className="project-card">
            <div className="project-title">Investments</div>
            <div className="project-copy">
              Equity and ETF research pages with dashboards, scoring, and detail views.
            </div>
            <a className="project-link" href="/#/investments">Open Investments</a>
          </div>
          <div className="project-card">
            <div className="project-title">Real Estate ROI Lab</div>
            <div className="project-copy">
              Stateless property underwriting with public-context enrichment, scenario analysis, and exportable results.
            </div>
            <a className="project-link" href="/#/real-estate/intake">Open Real Estate ROI Lab</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mobile;
